import { ErrorBoundary } from "react-error-boundary";
import { useLocation, useNavigate } from "react-router-dom";
import '@/component/ErrorBoundery/errorBoundary.css';

function ErrorFallback({ error, resetErrorBoundary }) {
  const navigate = useNavigate();

  return (
		<div className="error-container">
			<div className="error-box">
				<h1 className="error-title">Something went wrong</h1>
				<p className="error-text">An unexpected error occurred. You can try again, or return to the home page.</p>
				<div className="error-buttons">
					<button className="error-button try-again" onClick={resetErrorBoundary}>
						Try Again
					</button>
					<button className="error-button go-home" onClick={() => navigate('/')}>
						Back To Home
					</button>
				</div>
			</div>
		</div>
	);
}

export default function AppErrorBoundary({ children }) {
  const location = useLocation();

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      resetKeys={[location.pathname]}
    >
      {children}
    </ErrorBoundary>
  );
}
